type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
  strokeWidth?: string;
};

const ChevronDownIcon = (props: Props) => {
  const {
    width = '10',
    height = '10',
    viewBox = '0 0 10 10',
    strokeColor = 'currentColor',
    strokeWidth = '1.5',
  } = props;
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M2 3.5L5 6.5L8 3.5"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChevronDownIcon;
